module.exports = __webpack_public_path__ + "site_static/img/solution1.c331a5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solution1.png
// module id = X48N
// module chunks = 0